import { render } from "./CabinetLayout.vue?vue&type=template&id=11764d9c&ts=true"
import script from "./CabinetLayout.vue?vue&type=script&lang=ts"
export * from "./CabinetLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__